
import { defineComponent } from 'vue'
import UserProfile from '../components/UserProfile.vue'
import { useRouter, useRoute } from 'vue-router'

export default defineComponent({
  name: 'Index',
  components: {
    UserProfile
  },
  setup() {
    const router = useRouter()
    const route = useRoute()

    const goCreateWork = () => {
      router.push({ name: 'EditorWork', params: { id: 'create' } })
    }
    const goWorks = () => {
      router.push('/works')
    }
    return {
      route,
      goCreateWork,
      goWorks
    }
  }
})
